import { Fragment, h, render } from "preact";
import BundleConfigratorVariantPicker from "./bundle-configurator-variant-picker.jsx";

const BundleConfiguratorContent = ({ data, form, bundle }) => {
  return (
    <Fragment>
      <div className="product-bundle__content-title copy-text">
        Included in this Build:
      </div>
      {bundle?.map((product, index) => (
        <BundleConfigratorVariantPicker
          data={data}
          product={product}
          form={form}
          key={product.id}
        />
      ))}
    </Fragment>
  );
};

export default BundleConfiguratorContent;
